module.exports = __webpack_public_path__ + "img/step3-1.559bc3bf.png";